import { InjectionToken } from '@angular/core';

export const LOGIN_REDIRECT_URL_FN = new InjectionToken<
  (idpHint?: string, queryParams?: Record<string, string>) => string
>('LOGIN_REDIRECT_URL_FN');
